import {IAuthenticationState, initialAuthenticationState} from "./security/authentication.state";
import {IAuthenticatedUserState, initialAuthenticatedUserState} from "./security/authenticated-user.state";
import {initialReportsDataState, IReportsDataState} from "./reports/reports.state";
import {initialTasksState, ITasksState} from "./tasks/tasks.state";
import {IAccountingState, IAccountOperationsState, initialAccountingState, initialAccountOperationsState} from "./accounting/accounting.state";
import {initialPartnersState, IPartnersState} from "./partners/partners.state";
import {initialResourcesState,  IResourcesState} from "./resources/resources.state";
import {IApplicationParametersState, ILanguageState, initialApplicationParametersState, initialLanguageState} from "./application-parameters/application-parameters.state";
import {initialOsaState, IOsaState} from "./osa/osa.state";
import {IMDMState, initialMDMState} from "./mdm/mdm.state";
import {DisplayMode} from "../actions/system/system.actions";
import {initialViewElementsState, IViewElementsState} from "./system/system.state";
import {emptyResource, IResource} from "@retail-data-factory/rdf-angular-types-api";
import {IConfigurationState, initialConfigurationState} from "./configuration/configuration.state";
import {initialTopPanelState, ITopPanelState} from "./top-panel/top-panel.state";
import {IMarketplaceState, initialMarketplaceState} from "./marketplace/marketplace.state";

export interface IAppState {
  configuration: IConfigurationState;
  authentication: IAuthenticationState;
  authenticatedUser: IAuthenticatedUserState;
  reports:IReportsDataState;
  tasks:ITasksState;
  accounting: IAccountingState;
  partners: IPartnersState;
  accountOperations: IAccountOperationsState;

  resources:IResourcesState;
  currentResource: IResource;

  language: ILanguageState;
  applicationParameters: IApplicationParametersState;


  osa: IOsaState;

  mdm: IMDMState;

  displayMode: DisplayMode;

  viewElements: IViewElementsState;
  topPanel: ITopPanelState;
  router;

  marketplace: IMarketplaceState;
}
export const initialAppState:IAppState = {
  configuration: initialConfigurationState,
  authentication: initialAuthenticationState,
  authenticatedUser: initialAuthenticatedUserState,
  reports: initialReportsDataState,
  tasks: initialTasksState,
  accounting: initialAccountingState,
  partners: initialPartnersState,
  accountOperations: initialAccountOperationsState,

  resources: initialResourcesState,
  currentResource: emptyResource,

  language: initialLanguageState,
  applicationParameters:initialApplicationParametersState,

  osa: initialOsaState,

  mdm: initialMDMState,

  displayMode: 'undefined',

  viewElements: initialViewElementsState,
  topPanel: initialTopPanelState,
  router: null,
  marketplace: initialMarketplaceState
};

export function getInitialState():IAppState {
  return initialAppState;
}
